import { rgba, rem } from 'polished'
import { createGlobalStyle } from 'styled-components'
import 'swiper/css/swiper.css'

import media from '../utils/media'

export default createGlobalStyle`
  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/949f99/00000000000000003b9b3068/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-family: "proxima-nova";
    src: url("https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),url("https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),url("https://use.typekit.net/af/576d53/00000000000000003b9b3066/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family:"proxima-nova";
    src:url("https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/705e94/00000000000000003b9b3062/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family:"adelle";
    src:url("https://use.typekit.net/af/d79a98/00000000000000003b9af917/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/d79a98/00000000000000003b9af917/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/d79a98/00000000000000003b9af917/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-family:"adelle";
    src:url("https://use.typekit.net/af/19af50/00000000000000003b9af920/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/19af50/00000000000000003b9af920/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/19af50/00000000000000003b9af920/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family:"adelle";
    src:url("https://use.typekit.net/af/01fb88/00000000000000003b9af921/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),url("https://use.typekit.net/af/01fb88/00000000000000003b9af921/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),url("https://use.typekit.net/af/01fb88/00000000000000003b9af921/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
    font-display: swap;
    font-style: normal;
    font-weight: 600;
  }

  :root {
    --proxima-nova: ${({ theme }) => theme.typography.fontFamily[0]};
    --adelle: ${({ theme }) => theme.typography.fontFamily[1]};
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    outline: none;
  }

  body {
    color: ${({ theme }) => theme.color.neutral600};
    font-weight: 400;
    font-family: var(--proxima-nova), sans-serif;
  }

  a, button {
    align-self: initial !important;
  }

  a,
  a > span,
  button {
    color: ${({ theme }) => theme.color.neutral600};
    transition: all .4s ease;

    &:hover {
      color: ${({ theme }) => theme.color.neutral900};
      text-decoration: none;
    }
  }

  .invisible {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    -webkit-clip-path: inset(0px 0px 99.9% 99.9%);
    clip-path: inset(0px 0px 99.9% 99.9%);
    overflow: hidden;
    height: 1px;
    width: 1px;
    padding: 0;
    border: 0;
  }

  /**
   * Helper With Shadow
   */
  .with-shadow {
    &-1dp,
    &-sm-1dp {
      box-shadow: 0 4px 6px -4px ${({ theme }) =>
        rgba(theme.color.neutral950, 0.35)};
    }

    &-2dp,
    &-sm-2dp {
      box-shadow: 0 7px 7px -4px ${({ theme }) =>
        rgba(theme.color.neutral950, 0.15)};
    }

    &-3dp,
    &-sm-3dp {
      box-shadow: 0 13px 10px -7px ${({ theme }) =>
        rgba(theme.color.neutral950, 0.15)};
    }

    &-4dp,
    &-sm-4dp {
      box-shadow: 0 20px 19px -10px ${({ theme }) =>
        rgba(theme.color.neutral950, 0.15)};
    }

    &-5dp,
    &-sm-5dp {
      box-shadow: 0 3px 30px ${({ theme }) =>
        rgba(theme.color.neutral950, 0.15)};
    }

    ${media.lessThan('sm')`
      &-sm-1dp,
      &-sm-2dp,
      &-sm-3dp,
      &-sm-4dp,
      &-sm-5dp {
        box-shadow: none;
      }
    `}
  }

  /**
   * Full on mobile
   */
  .full {
    ${media.lessThan('sm')`
      &-mobile {
        padding-right: 0 !important;
        padding-left: 0 !important;
        margin-right: 0 !important;
        margin-left: 0 !important;

        .switch-pd {
          padding-left: 1.5rem;
          padding-right: 1.5rem;
        }
      }
    `}
  }

  /**
   * Remove border radius
   */
  .br {
    &-none {
      border-radius: 0 !important;

      ${media.lessThan('lg')`
        &-lg {
          border-radius: 0 !important;
        }
      `}

      ${media.lessThan('md')`
        &-md {
          border-radius: 0 !important;
        }
      `}

      ${media.lessThan('sm')`
        &-sm {
          border-radius: 0 !important;
        }
      `}

      ${media.lessThan('xs')`
        &-xs {
          border-radius: 0 !important;
        }
      `}
    }
  }

  /**
   * Helper Display Block/None
   */
  .d {
    &-none {
      display: none !important;
    }

    &-inline-block {
      display: inline-block !important;
    }

    &-block {
      display: block !important;
    }

    &-flex {
      display: flex !important;
    }

    ${media.greaterThan('xs')`
      &-xs {
        &-none {
          display: none !important;
        }

        &-inline-block {
          display: inline-block !important;
        }

        &-block {
          display: block !important;
        }

        &-flex {
          display: flex !important;
        }
      }
    `}

    ${media.greaterThan('sm')`
      &-sm {
        &-none {
          display: none !important;
        }

        &-inline-block {
          display: inline-block !important;
        }

        &-block {
          display: block !important;
        }

        &-flex {
          display: flex !important;
        }
      }
    `}

    ${media.greaterThan('md')`
      &-md {
        &-none {
          display: none !important;
        }

        &-inline-block {
          display: inline-block !important;
        }

        &-block {
          display: block !important;
        }

        &-flex {
          display: flex !important;
        }
      }
    `}

    ${media.greaterThan('lg')`
      &-lg {
        &-none {
          display: none !important;
        }

        &-inline-block {
          display: inline-block !important;
        }

        &-block {
          display: block !important;
        }

        &-flex {
          display: flex !important;
        }
      }
    `}
  }

  /**
   * Helper Background Size
   */
  .bg {
    &-cover,
    &-cover-before::before,
    &-cover-after::after {
      background-size: cover !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
    }

    &-contain,
    &-contain-before::before,
    &-contain-after::after {
      background-size: contain !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
    }
  }

  /**
   * Helper Has Icon
   */
  .has-icon {
    &-left {
      .icon {
        margin-right: 8px;
      }
    }

    &-right {
      .icon {
        margin-left: 8px;
      }
    }
  }

  /**
   * Helper Text Align
   */
  .tx {
    &-center {
      text-align: center;
    }
    &-left {
      text-align: left;
    }
    &-right {
      text-align: right;
    }
  }

  /**
   * Helper responsive img
   */
  .img-fluid {
    max-width: 100%;
    height: auto;
  }

  /**
   * Breadcrumbs
   */
  .breadcrumb {
    margin-right: auto;

    &__list {
      display: flex;
      align-items: center;
    }

    &__title {
      display: none;
    }

    &__title,
    &__separator,
    &__link,
    &__link__active {
      line-height: 1;
      letter-spacing: .5px;
      text-transform: uppercase;
      text-decoration: none;
      font-size: ${rem(12)};
      font-weight: 700;
      color: ${({ theme }) => theme.color.neutral500};
    }

    &__separator {
      margin: 0 10px;
    }

    &__list__item {
      &:last-of-type {
        a {
          color: ${({ theme }) => theme.color.neutral800};
        }
      }
    }

    ${media.lessThan('sm')`
      &__list__item {
        a {
          color: ${({ theme }) => theme.color.neutral800};
        }

        &:not(:first-of-type) {
          display: none;
        }
      }

      &__separator {
        display: none;
      }
    `}
  }

  .Toastify__toast-container {
    z-index: 9999;
    -webkit-transform: translate3d(0, 0, 9999px);
    position: fixed;
    padding: 4px;
    width: 400px;
    box-sizing: border-box;
    color: #fff;
  }
  .Toastify__toast-container--top-left {
    top: 1em;
    left: 1em;
  }
  .Toastify__toast-container--top-center {
    top: 3em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--top-right {
    top: 1em;
    right: 1em;
  }
  .Toastify__toast-container--bottom-left {
    bottom: 1em;
    left: 1em;
  }
  .Toastify__toast-container--bottom-center {
    bottom: 1em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--bottom-right {
    bottom: 1em;
    right: 1em;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast-container {
      width: 90vw;
      padding: 0;
      /* left: 0;
      margin: 0; */
    }
    .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
      /* top: 0; */
      /* transform: translateX(0); */
    }
    .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
      bottom: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--rtl {
      right: 0;
      left: initial;
    }
  }
  .Toastify__toast {
    position: relative;
    min-height: 64px;
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 24px;
    border-radius: 4px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
        justify-content: space-between;
    max-height: 800px;
    font-size: 13px;
    overflow: hidden;
    cursor: pointer;
    direction: ltr;
  }
  .Toastify__toast--rtl {
    direction: rtl;
  }
  .Toastify__toast--dark {
    background: #121212;
    color: ${({ theme }) => theme.color.white};
  }
  .Toastify__toast--default {
    background: ${({ theme }) => theme.color.white};
    color: #aaa;
  }
  .Toastify__toast--info {
    background: ${({ theme }) => theme.color.blue500};
  }
  .Toastify__toast--success {
    background: ${({ theme }) => theme.color.green500};
  }
  .Toastify__toast--warning {
    background: ${({ theme }) => theme.color.yellow500};
  }
  .Toastify__toast--error {
    background: ${({ theme }) => theme.color.red500};
  }
  .Toastify__toast-body {
    margin: auto 5px auto 0;
    -ms-flex: 1 1 auto;
        flex: 1 1 auto;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast {
      margin-bottom: 0;
    }
  }
  .Toastify__close-button {
    color: ${({ theme }) => theme.color.white};
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    -ms-flex-item-align: start;
        align-self: flex-start;
  }
  .Toastify__close-button--default {
    color: ${({ theme }) => theme.color.white};
    opacity: 0.3;
  }
  .Toastify__close-button > svg {
    fill: ${({ theme }) => theme.color.white};
    height: 16px;
    width: 14px;
  }
  .Toastify__close-button:hover, .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 9999;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }
  .Toastify__progress-bar--rtl {
    right: 0;
    left: initial;
    transform-origin: right;
  }
  .Toastify__progress-bar--default {
    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  }
  .Toastify__progress-bar--dark {
    background: #bb86fc;
  }
  @keyframes Toastify__bounceInRight {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInLeft {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0);
    }
    75% {
      transform: translate3d(-10px, 0, 0);
    }
    90% {
      transform: translate3d(5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInUp {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    75% {
      transform: translate3d(0, 10px, 0);
    }
    90% {
      transform: translate3d(0, -5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }
    40%, 45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }
  @keyframes Toastify__bounceInDown {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0);
    }
    40%, 45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }
  }
  .Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft;
  }
  .Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }
  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }
  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }
  .Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }
  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }
  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
      opacity: 1;
    }
  }
  @keyframes Toastify__zoomOut {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    to {
      opacity: 0;
    }
  }
  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn;
  }

  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut;
  }

  @keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1;
    }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }
    to {
      transform: perspective(400px);
    }
  }
  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px);
    }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1;
    }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0;
    }
  }
  .Toastify__flip-enter {
    animation-name: Toastify__flipIn;
  }

  .Toastify__flip-exit {
    animation-name: Toastify__flipOut;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0);
    }
  }
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0);
    }
  }
  .Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft;
  }
  .Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }
  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }
  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft;
  }
  .Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
  }
  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
  }
  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
  }
`
